<template lang="pug">
#explore
  .nav#explore-nav
    #filters.pull-left
      v-touch.filter(:class="{ 'active': sort === 'POPULAR' }" @tap="sort='POPULAR'")
        .label Popular
        icon(icon="fire")
      v-touch.filter(:class="{ 'active': sort === 'LATEST' }" @tap="sort='LATEST'")
        .label Latest
        icon(icon="arrow-down")
    //- .divider
        
    #filters.pull-right
      v-touch.filter(:class="{ 'active': size === 'small' }" @tap="size='small'")
        icon(icon="th")
      v-touch.filter(:class="{ 'active': size === 'large' }" @tap="size='large'")
        icon(icon="th-large")
      .clearfix
    .clearfix

  gallery(type="feed" :sort.sync="sort" :size.sync="size")
</template>

<script>
// Components
import Gallery from "@/components/Gallery";

export default {
  name: "Explore",
  components: {
    Gallery
  },
  data() {
    return {
      sort: "POPULAR",
      size: "small"
    };
  }
};
</script>

<style lang="stylus">
#explore {
  #explore-nav {
    display: block;
    padding: 20px 0px 20px 0px;
    text-align: left;

    +mobile() {
      padding: 20px 20px 20px 20px;
    }

    #filters {
      .filter {
        animate();
        float: left;
        opacity: 0.5;
        padding: 10px;

        .label {
          display: inline;
          margin-right: 5px;
        }

        &.active {
          color: $color-info;
          opacity: 1;
        }

        &:hover {
          cursor: pointer;
          opacity: 1;
        }
      }

      .divider {
        background-color: $color-border;
        float: left;
        height: 20px;
        margin: 10px;
        width: 1px;
      }
    }
  }

  #posts {
    overflow-y: auto;
  }
}
</style>
